import { render, staticRenderFns } from "./ForgetPasswordPage.vue?vue&type=template&id=bdf1f12a&scoped=true&"
import script from "./ForgetPasswordPage.vue?vue&type=script&lang=js&"
export * from "./ForgetPasswordPage.vue?vue&type=script&lang=js&"
import style0 from "./ForgetPasswordPage.vue?vue&type=style&index=0&id=bdf1f12a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf1f12a",
  null
  
)

export default component.exports